import React, { useState, useEffect } from "react";
import Images from "../../../media/images";
import api from "../../../api/api";
import TransactionUpdate from "./TransactionUpdate";
import { toast } from "react-toastify";

const TransactionList = () => {
  const [transactionList, setTransactionList] = useState([]);
  const [change, setChange] = useState(true)


  useEffect(() => {
    api
      .get("/transactions/")
      .then((response) => {
        // console.log(response.data);
        setTransactionList(response.data);
      })
      .catch((error) => {});
  }, [change]);


  const handleApprove = (id) => {
    api.patch(`/transactions/${id}/approve/`)
    .then(response=> {
      toast.success("Approved")
      setChange(!change)
    }).catch(error=> {
      console.log(error)
    })
  }


  return (
    <div>
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Transaction List
      </h1>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>
      <div className="px-10">
        <table className="min-w-full text-center">
          <thead className="font-Bree bg-primary-red border-b font-bold">
            <tr>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                SN.
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Company Name
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Customer Name
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Payment Details
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Amount
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                status
              </th>
              <th
                scope="col"
                className="px-6 py-4 text-sm font-medium text-white"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody className="font-Acme">
            {transactionList.map((item, i) => {
              return (
                <tr className="border-primary-blue border-2 bg-white" key={i}>
                  <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                    {i + 1}
                  </td>

                  <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                    {/* 2078/1/1 */}
                    {item.company_name}
                  </td>

                  <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                    {item.customer_name}
                  </td>

                  <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                    {item?.payment_details ? item.payment_details : "null"}
                  </td>

                  <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                    {item.amount}
                  </td>

                  <td>{item.status}</td>


                  <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                    <button 
                    className="bg-primary-blue hover:bg-red-500 rounded-full p-1 px-2 text-white"
                    onClick={()=> handleApprove(item.id)}
                    >
                      Approve
                    </button>

                    <button 
                    className="bg-primary-blue hover:bg-red-500 rounded-full p-1 px-2 mx-2 text-white"
                    data-bs-toggle="modal"
                    data-bs-target = "#TransactionModal"
                    >
                      Update
                    </button>
                    <TransactionUpdate />

                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionList;
